module.exports = __webpack_public_path__ + "img/web6.b712b486.svg";